import { Button } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

export const NavButton = ({ to, text, onClick }) => {
    return (
        <Button
            as={RouterLink}
            to={to}
            colorScheme="blackAlpha"
            size="lg"
            height="60px"
            fontSize="3xl"
            onClick={onClick}
            _hover={{ bg: "whiteAlpha.200" }}
            color="white"
            justifyContent="flex-end"
        >
            {text}
        </Button>
    );
};
